<template>
  <div
    class="content-body rounded-5 d-flex justify-content-between align-items-center nowrap w-100"
  >
    <div class="left d-flex justify-content-start align-items-center nowrap">
      <div
        class="avatar-box rounded-5 mr-3"
        :class="is_loading ? 'skeleton-loader' : 'border_grey_light_bg'"
      ></div>
      <div class="info-box">
        <div
          class="top"
          :class="is_loading ? 'skeleton-loader' : 'border_grey_light_bg'"
        ></div>
        <div
          class="bottom"
          :class="is_loading ? 'skeleton-loader' : 'border_grey_light_bg'"
        ></div>
      </div>
    </div>
    <div
      class="right rounded-5"
      :class="is_loading ? 'skeleton-loader' : 'border_grey_light_bg'"
    ></div>
  </div>
</template>

<script>
export default {
  name: "WeeklyDefaultRow",

  components: {},

  props: {
    is_loading: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.content-body {
  background: rgba(white, 0.5);
  padding: 12px 20px;
  margin-bottom: 2px;

  @include breakpoint_max(md) {
    padding: 8px;
  }

  .left {
    .avatar-box {
      @include custom_min_edge(60, 42);
      @include breakpoint_max(md) {
        @include custom_min_edge(52, 38);
      }
      @include breakpoint_max(sm) {
        @include custom_min_edge(48, 38);
      }
    }

    .top {
      width: 272px;
      height: 18px;
      margin-bottom: 7px;

      @include breakpoint_max(md) {
        width: 250px;
        height: 16px;
      }

      @include breakpoint_max(sm) {
        width: 210px;
      }
      @include breakpoint_max(xs) {
        width: 170px;
      }
    }
    .bottom {
      width: 200px;
      height: 13px;

      @include breakpoint_max(md) {
        width: 180px;
        height: 12px;
      }

      @include breakpoint_max(sm) {
        width: 140px;
      }

      @include breakpoint_max(xs) {
        width: 100px;
      }
    }
  }

  .right {
    width: 118px;
    height: 30px;

    @include breakpoint_max(md) {
      width: 90px;
      height: 27px;
    }

    @include breakpoint_max(sm) {
      width: 70px;
    }
  }
}
</style>